import store from '../store'
export default {
  beforeRouteLeave (to, from, next) {
    if (!to.path.includes(from.path)) {
      store.commit('removeKeepAlive', this.$options.name)
    }
    next()
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      store.commit('addKeepAlive', vm.$options.name)
    })
  },
  activated () {
    if (this.initData) {
      this.initData()
    } else {
      this.$options.created.forEach(fun => {
        fun.call(this)
      })
    }
  }
}
